(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/product-settings.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/product-settings.js');
"use strict";


const DEFAULT_PRODUCT = 'start';
const urlMapping = svs.core.urlMapping;
const buildProductSettings = () => {
  const settings = {
    stryktipset: {
      productType: 'stryktipset',
      productName: 'Stryktipset',
      productTemplateName: 'tipsen',
      urlName: svs.core.urlMapping.get('stryktipsetHome'),
      urlNameNova: svs.core.urlMapping.get('stryktipsetHome'),
      allowFiltering: false
    },
    europatipset: {
      productType: 'europatipset',
      productName: 'Europatipset',
      productTemplateName: 'tipsen',
      urlName: urlMapping.get('europatipsetHome'),
      urlNameNova: urlMapping.get('europatipsetHome'),
      allowFiltering: false
    },
    topptipset: {
      productType: 'topptipset',
      productName: 'Topptipset',
      productTemplateName: 'tipsen',
      urlName: urlMapping.get('topptipsetHome'),
      urlNameNova: urlMapping.get('topptipsetHome'),
      allowFiltering: false
    },
    powerplay: {
      productType: 'powerplay',
      productName: 'powerplay',
      productTemplateName: 'tipsen',
      urlName: urlMapping.get('powerplayHome'),
      urlNameNova: urlMapping.get('novaPowerplayHome'),
      allowFiltering: false
    }
  };
  settings.maltipset = {
    productType: 'maltipset',
    productName: 'Måltipset',
    productTemplateName: 'tipsen',
    urlName: urlMapping.get('maltipsetHome'),
    urlNameNova: urlMapping.get('maltipsetHome'),
    allowFiltering: false
  };
  settings.challenge = {
    productType: 'challenge',
    productName: 'Challenge',
    productTemplateName: 'tipsen',
    urlName: urlMapping.get('challengeHome'),
    urlNameNova: urlMapping.get('challengeHome'),
    allowFiltering: true
  };
  settings.bomben = {
    productType: 'bomben',
    productName: 'Bomben',
    productTemplateName: 'bomben',
    urlName: urlMapping.get('bombenHome'),
    urlNameNova: urlMapping.get('bombenHome'),
    allowFiltering: true
  };
  settings.matchen = {
    productType: 'matchen',
    productName: 'Matchen',
    productTemplateName: 'bomben',
    urlName: urlMapping.get('matchenHome'),
    urlNameNova: urlMapping.get('matchenHome'),
    allowFiltering: true
  };
  settings.start = {
    productType: 'start',
    productName: 'start',
    productTemplateName: 'start',
    urlName: 'start',
    urlNameNova: 'start',
    allowFiltering: false
  };
  return settings;
};
setGlobal('svs.tt.productSettings', buildProductSettings());
setGlobal('svs.tt.defaultProduct', DEFAULT_PRODUCT);

 })(window);